/**
 * Checks if the given value is a number.
 */
export const isNumber = (value: unknown) => typeof value === "number" && Number.isNaN(value) === false
